import api from "./api";

const appendImages = (formData, images = []) => {
  images.forEach((image) => formData.append("images", image));
};

export const buildSupportIssueFormData = ({ subject, body, status, images = [] }) => {
  const formData = new FormData();

  if (subject !== undefined) formData.append("subject", subject);
  if (body !== undefined) formData.append("body", body);
  if (status) formData.append("status", status);
  appendImages(formData, images);

  return formData;
};

export const listSupportIssues = async (params = {}) => {
  const { data } = await api.get("/support-issues", { params });
  return data;
};

export const listSupportCompanies = async (params = {}) => {
  const { data } = await api.get("/support-issues/companies", { params });
  return data;
};

export const getSupportIssue = async (issueId, params = {}) => {
  const { data } = await api.get(`/support-issues/${issueId}`, { params });
  return data;
};

export const createSupportIssue = async (payload) => {
  const { data } = await api.post(
    "/support-issues",
    buildSupportIssueFormData(payload)
  );
  return data;
};

export const createSupportIssueMessage = async (issueId, payload) => {
  const { data } = await api.post(
    `/support-issues/${issueId}/messages`,
    buildSupportIssueFormData(payload)
  );
  return data;
};

export const updateSupportIssueStatus = async (issueId, status) => {
  const { data } = await api.patch(`/support-issues/${issueId}/status`, { status });
  return data;
};

export const markSupportIssueRead = async (issueId, lastReadMessageId) => {
  const { data } = await api.post(`/support-issues/${issueId}/read`, {
    lastReadMessageId,
  });
  return data;
};

export const getSupportUnreadCount = async () => {
  const { data } = await api.get("/support-issues/unread-count");
  return data;
};

export const getSupportAttachment = async (attachmentId) => {
  const response = await api.get(`/support-issues/attachments/${attachmentId}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    contentType: response.headers?.["content-type"],
  };
};

export const isAmbiguousSupportRequestError = (error) => {
  if (!error?.response) return true;

  return error.response.status === 503 &&
    error.response.data?.error === "ERR_SUPPORT_WRITE_UNCERTAIN";
};

const ERROR_MESSAGES = {
  ERR_SUPPORT_REPLY_WAITING_SUPPORT: "Aguarde a resposta da equipe para enviar uma nova mensagem. Seu rascunho foi mantido.",
  ERR_SUPPORT_CLOSED: "Este chamado foi finalizado. Seu rascunho foi mantido; a equipe precisa reabrir o chamado para receber uma nova resposta.",
  ERR_SUPPORT_VALIDATION: "Revise os campos informados e tente novamente.",
  ERR_SUPPORT_UNAUTHORIZED: "Sua sessão expirou. Entre novamente para continuar.",
  ERR_SUPPORT_FORBIDDEN: "Você não tem permissão para realizar esta ação.",
  ERR_SUPPORT_NOT_FOUND: "Este chamado não está mais disponível.",
  ERR_SUPPORT_CONFLICT: "O chamado mudou enquanto você o visualizava. Atualize e tente novamente.",
  ERR_SUPPORT_FILE_TOO_LARGE: "Uma das imagens ultrapassa o limite permitido.",
  ERR_SUPPORT_TOO_MANY_FILES: "Envie no máximo cinco imagens.",
  ERR_SUPPORT_RATE_LIMIT: "Muitas tentativas em pouco tempo. Aguarde antes de tentar novamente.",
};

export const getSupportErrorMessage = (error, fallback) => {
  const code = error?.response?.data?.error;
  return ERROR_MESSAGES[code] || fallback;
};
